module.exports = __webpack_public_path__ + "static/media/forca-vendas.4de8e471.png";